<template>
  <div>
    <div>
      <v-card flat class="px-4 rounded-lg py-3">
        <div v-if="!loading && dataSetUniv">
          <div class="d-flex align-start">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="black"
                  v-bind="attrs"
                  v-on="on"
                  @click="$router.go(-1)"
                  icon
                  class="mr-3"
                  ><v-icon>mdi-reply</v-icon></v-btn
                >
              </template>
              <span>Back</span>
            </v-tooltip>
            <div>
              <h2>{{ dataSetUniv.name }}</h2>
              <h3 style="font-weight: normal; color: rgba(0, 0, 0, 0.4)">
                {{ dataSetUniv.email }}
              </h3>
            </div>
          </div>
        </div>
        <div v-if="loading">
          <v-skeleton-loader
            type="list-item-three-line"
            height="90px"
          ></v-skeleton-loader>
        </div>
      </v-card>

      <div v-if="!loading" class="my-5 d-flex align-center">
        <h4>List Registered Event</h4>
        <v-btn class="ml-4 btn" color="#016443">
          <h4 style="color: white; font-weight: normal">Export Data</h4>
        </v-btn>
      </div>
      <div>
        <v-skeleton-loader
          class="my-5"
          type="table-tbody"
          v-if="loading"
        ></v-skeleton-loader>
        <div v-if="dataSet && !loading && dataSet">
          <v-data-table
            :headers="headers"
            :items="dataSet"
            :page.sync="page"
            :items-per-page="limit"
            class="elevation-0 color_txt"
          >
            <template v-slot:[`item.created_at`]="{ item }">
              <h4 style="font-weight: normal">
                {{ $date(item.created_at).format("MMM DD, YYYY") }}
              </h4>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <div class="d-flex">
                <v-btn
                  class="mr-2"
                  icon
                  :to="`/admin/tsa/tsa-proposal/list-detail/${item.tsa.id}/${item.id}`"
                >
                  <v-icon color="#000000">mdi-eye</v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </div>
        <div class="text-center my-2 pa-3" v-if="dataSet">
          <v-pagination
            v-model="page"
            color="#006341"
            @input="fetchData"
            :length="last_page"
          ></v-pagination>
        </div>
        <div
          class="empty d-flex align-center justify-center flex-column"
          v-if="!dataSet && !loading"
        >
          <img
            src="../../../../../assets/img/redaksi/pagenotfound.png"
            height="250px"
            alt=""
          />
          <b class="default_txt my-3">Data not found</b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({}),
  },
  name: "listResponseTsa",
  components: {},
  data() {
    return {
      loading: false,
      dataSet: null,
      dataSetUniv: null,
      page: 1,
      limit: 10,
      find: "",
      headers: [
        {
          text: "Name",
          align: "start",
          value: "tsa.name",
        },
        {
          text: "Title Event",
          align: "start",
          value: "title",
        },
        {
          text: "Submitted Date",
          align: "start",
          value: "created_at",
        },
        {
          text: "Type Category",
          align: "start",
          value: "category.name",
        },
        { text: "Actions", sortable: false, value: "actions" },
      ],
    };
  },
  mounted() {
    this.fetchDataUniv();
  },
  methods: {
    fetchDataUniv() {
      this.loading = true;
      let data = {
        path: `manage/univ/get?filter[id]=${this.$route.params.idTsa}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSetUniv = data.data[0];
          this.fetchData();
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    fetchData() {
      this.loading = true;
      let data = {
        path: `tsa-proposal/admin/register?page[number]=${this.page}&page[size]=${this.limit}&filter[search]=${this.find}&include=category,tsa&filter[tsa_id]=${this.$route.params.idTsa}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.loading = false;
          this.dataSet = data.data;
          this.total = data.total;
          this.last_page = data.last_page;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>
